module.exports = __webpack_public_path__ + "img/pic1.2ea2c6ac.jpg";